import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isAdmin } from 'shared/domain/role/isAdmin';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { isStandard } from 'shared/domain/role/isStandard';
import { isViewer } from 'shared/domain/role/isViewer';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoUsers } from 'views/users/table';
import { MemoUser } from 'views/users/single';
import { MemoCreateUserWizardContainer } from 'views/users/wizard/create/container';
import { MemoEditUserWizardContainer } from 'views/users/wizard/edit/container';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';
export const AuthorizableUsers = React.memo((): React.ReactElement => {
  const role = useCurrentUserRole();
  const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
  return (
    <MemoGenericRoleAuthorizer
      authorized={isManagerOrAdmin(role)}
      unauthorized={isCurrentUserStandardOrViewer}
      authorizedComponent={MemoUsers}
      unauthorizedComponent={InsufficientPermissionsPage}
    />
  );
});

export const AuthorizableCreateUserWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserAdmin = isAdmin(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={MemoCreateUserWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableUser = React.memo((): React.ReactElement => {
  const role = useCurrentUserRole();
  const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
  return (
    <MemoGenericRoleAuthorizer
      authorized={isManagerOrAdmin(role)}
      unauthorized={isCurrentUserStandardOrViewer}
      authorizedComponent={MemoUser}
      unauthorizedComponent={InsufficientPermissionsPage}
    />
  );
});

export const AuthorizableEditUserWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserAdmin = isAdmin(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={MemoEditUserWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
